import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$company/buchhaltung/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$company/buchhaltung/eingang",
      params: { company: params.company },
      replace: true,
    });
  },
});
